import React, { useState } from 'react'
import { CheckboxControl, DialogControl, FieldControl } from 'spark-core-dx/components';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';
import { useCorePermissions, useValidationErrors } from 'spark-core-dx/hooks';
import { SystemTypes } from 'spark-core-dx/services';

const DashboardCreateDialog = ({ isActive, closeDialog }) => {
    const {
        iconSelectData,
        createNewDashboard,
    } = useDashboardDomainContext();

    const { canCreate } = useCorePermissions();

    const { hasAndShowValidationErrors } = useValidationErrors()

    const [dashCreationObject, setDashCreationObject] = useState({
        name: "",
        description: "",
        icon: "",
        isTemplate: false
    })

    const clearDashCreationObject = () => {
        setDashCreationObject({
            name: "",
            description: "",
            icon: "",
            isTemplate: false
        })
    }

    const [error, setError] = useState(false);

    return (
        <DialogControl
            className={"dashboard-dialog"}
            openDialog={isActive}
            disableOk={dashCreationObject?.name.trim() === ""}
            title={"Design a New Dashboard"}
            onOk={async () => {
                if (!hasAndShowValidationErrors("dashboard")) {
                    return createNewDashboard(dashCreationObject)
                        .then((status) => {
                            if (status) {
                                setError(false);
                                closeDialog();
                                clearDashCreationObject();
                            }
                        })
                        .catch((status) => {
                            // We can use status with real codes to have custom error messages per status.
                            if (!status) {
                                setError(true)
                            }
                        })

                }
            }}
            onCancel={() => {
                closeDialog();
                clearDashCreationObject();
                setError(false);
            }}
            okText={"Design"}
        >
            <div className="dialog-text">
                <FieldControl
                    fieldMetadata={{
                        FieldType: SystemTypes.UIFieldType.TextBox,
                        IsRequired: true,
                        FieldName: "DashboardName",
                        DisplayName: "Dashboard Name"
                    }}
                    groupId={"dashboard"}
                    value={dashCreationObject?.name}
                    onChange={v => {
                        setDashCreationObject(prev => ({
                            ...prev,
                            name: v,
                        }));
                    }}
                />
                <FieldControl
                    fieldMetadata={{
                        FieldType: SystemTypes.UIFieldType.TextBox,
                        FieldName: "DashboardDescription",
                        DisplayName: "Dashboard Description"
                    }}
                    groupId={"dashboard"}
                    value={dashCreationObject?.description}
                    onChange={v => {
                        setDashCreationObject(prev => ({
                            ...prev,
                            description: v,
                        }));
                    }}
                />
                <FieldControl
                    fieldMetadata={{
                        FieldType: SystemTypes.UIFieldType.SearchSelectList,
                        FieldName: "DashboardIcon",
                        DisplayName: "Icon",
                        DataJson: iconSelectData
                    }}
                    groupId={"dashboard"}
                    value={dashCreationObject?.icon}
                    onChange={v => {
                        setDashCreationObject(prev => ({
                            ...prev,
                            icon: v,
                        }));
                    }}
                />
                {canCreate("DashboardTemplateCreator") && (
                    <div className="checkbox">
                        <CheckboxControl value={dashCreationObject.isTemplate}
                            onChange={() => {
                                setDashCreationObject(prev => ({
                                    ...prev,
                                    isTemplate: !prev.isTemplate,
                                }));
                            }}
                        />
                        Mark as Template
                    </div>
                )}
            </div>
        </DialogControl>
    )
}

export default DashboardCreateDialog